/**
 * Created by comoon on 8/25/15.
 */

var _ = require("underscore");

var keyMirror = require("keymirror");

var _limit = {
    adult: 8,
    child: 4,
    room: 4,
    car: 4
};

function HeadCount(max = 8, min = 0, current = 0, type = "") {
    this.limit = _limit;
    this.max = max;
    this.min = min;
    this.current = current;
    this.getType = function () {
        return type;
    }
}

function HCCalculator(limit = true) {
    this[HCCalculator.Type.adult] = new HeadCount(8, 0, 0, HCCalculator.Type.adult);
    this[HCCalculator.Type.child] = new HeadCount(4, 0, 0, HCCalculator.Type.child);
    this[HCCalculator.Type.room] = new HeadCount(2, 0, 0, HCCalculator.Type.room);
    this[HCCalculator.Type.car] = new HeadCount(2, 0, 0, HCCalculator.Type.car);
    this.limit = limit;
}

HCCalculator.Type = keyMirror({
    adult: null,
    child: null,
    room: null,
    car: null
});

HCCalculator.TypeList = _.values(HCCalculator.Type);

HCCalculator.prototype.update = function (type, current) {
    current = +current;
    if (!_.contains(HCCalculator.TypeList, type)) {
        throw "You have passed error type[" + type + "] to HCCalculator";
    }
    this[type].current = current;
    this.updateLimit(this.limit);
    return this;
};

HCCalculator.prototype.updateLimit = function (limit) {
    this.limit = limit;
    if (limit) {
        return limitCount(this);
    } else {
        return removeLimit(this);
    }
};

HCCalculator.prototype.toShort = function () {
    return {
        adtCnt: this[HCCalculator.Type.adult].current,
        chdCnt: this[HCCalculator.Type.child].current,
        roomCnt: this[HCCalculator.Type.room].current,
        carCnt: this[HCCalculator.Type.car].current
    }
};

function limitCount(calculator) {
    let adult = calculator.adult;
    let child = calculator.child;
    let room = calculator.room;
    let car = calculator.car;

    adult.min = 0;
    adult.max = _limit.adult;
    adult.current = Math.max(adult.min, Math.min(adult.current, adult.max));

    child.max = Math.min(_limit.child, adult.current * 2);
    child.current = Math.min(child.current, child.max);

    room.max = Math.min(_limit.room, adult.current);
    room.min = Math.max(Math.ceil(adult.current / 2), Math.ceil((adult.current + child.current) / 3));
    room.current = Math.max(room.min, Math.min(room.current, room.max));

    car.max = Math.min(_limit.car, adult.current);
    car.min = Math.ceil((adult.current + child.current) / 4);
    if (car.current !== 0) {//因为可以选择不租车
        car.current = Math.max(car.min, Math.min(car.current, car.max));
    }

    return calculator;
}

function removeLimit(calculator) {
    _.each(HCCalculator.TypeList, function (type) {
        calculator[type].max = _limit[type];
        calculator[type].min = 0;
    });
    return calculator;
}

module.exports = {Calculator: HCCalculator};


/** WEBPACK FOOTER **
 ** ./script/util/head-count.js
 **/